import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { graphql } from 'src/gql'

import { logError } from '../../../common/logger'

const CreateVerificationCodeOverrideMutation = graphql(`
  mutation CreateVerificationCodeOverride($input: CreateVerificationCodeOverrideInput!) {
    createVerificationCodeOverride(input: $input) {
      success
      message
    }
  }
`)

type CreateVerificationCodeOverrideInput = {
  phoneNumber: string
  code: string
  memberId: number
}

export const useCreateVerificationCodeOverride = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [mutate, { loading }] = useMutation(CreateVerificationCodeOverrideMutation, {
    onCompleted: ({ createVerificationCodeOverride: { success, message } }) => {
      enqueueSnackbar(message, { variant: success ? 'success' : 'error' })
    },
    onError: error => {
      logError('Error creating verification code override', error)
      enqueueSnackbar('Could not create the verification code override.', { variant: 'error' })
    },
  })

  return {
    createVerificationCodeOverride: async (input: CreateVerificationCodeOverrideInput) =>
      await mutate({ variables: { input } }),
    loading,
  }
}